"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Box = _interopRequireDefault(require("../../Containers/Box"));
var _excluded = ["isOpen", "labelDetails"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var propTypes = {
  /** Wether the menu is open or closed */
  isOpen: _propTypes["default"].bool,
  /** Label has details such as image source and alt text */
  labelDetails: _propTypes["default"].shape({
    /** Source for the white label when menu is open (expanded) */
    src: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].bool]),
    /** Source for the white label when menu is closed (collapsed) */
    srcCollapsed: _propTypes["default"].string,
    /** Alt text */
    alt: _propTypes["default"].string
  })
};
var Container = (0, _styledComponents["default"])(_Box["default"]).attrs(function (props) {
  return {
    d: "flex",
    alignItems: props.alignItems || "center",
    justifyContent: props.justifyContent || "center"
  };
}).withConfig({
  displayName: "WhiteLabel__Container",
  componentId: "sc-7jseim-0"
})(["height:64px;padding:", ";img{max-height:", ";width:auto;max-width:100%;opacity:0.7;}"], function (props) {
  return props.theme.spaces.base;
}, function (props) {
  return props.isOpen ? "26px" : "16px";
});
var WhiteLabel = function WhiteLabel(_ref) {
  var isOpen = _ref.isOpen,
    labelDetails = _ref.labelDetails,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(Container, {
    isOpen: isOpen,
    justifyContent: isOpen ? "flex-end" : "center"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: isOpen ? labelDetails.src : labelDetails.srcCollapsed,
    alt: labelDetails.alt
  }));
};
WhiteLabel.propTypes = propTypes;
var _default = WhiteLabel;
exports["default"] = _default;